import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  WarningFilled,
} from '@ant-design/icons'
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import cls from 'classnames'
import LazyComponent from 'components/LazyComponent'
import { useCssInJs } from 'hooks/useCssInJs'
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'
import { Outlet } from 'react-router-dom'
import { isProdEnv } from 'utils/common'
import Env from '@micun/web-components/dist/components/Layout/EnvNew'
import Logo from './Logo'
import { Menu } from './Menu'
import { genLayoutStyle } from './styles'
import { UserInfo } from './UserInfo'

type AppConfig = {
  appCode: string
}

type Props = {
  config: AppConfig
} & PropsWithChildren

type TLayoutContext = {
  config: AppConfig
  collapsed?: boolean
  setCollapsed: (collapsed: boolean | ((collapsed: boolean) => boolean)) => void
  baseBreadcrumb: BreadcrumbItemType[]
  setBaseBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
  breadcrumb: BreadcrumbItemType[]
  setBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
}

export const LayoutContext = React.createContext<TLayoutContext>(null!)

export function useLayout() {
  return useContext(LayoutContext)
}

export function LayoutProvider(props: Props) {
  const { children, config } = props
  const [collapsed, setCollapsed] = useState(
    localStorage['collapsed'] === 'true' || false
  )
  const [baseBreadcrumb, setBaseBreadcrumb] = useState<BreadcrumbItemType[]>([])
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItemType[]>([])

  useEffect(() => {
    localStorage['collapsed'] = collapsed
  }, [collapsed])
  return (
    <LayoutContext.Provider
      value={{
        config,
        collapsed,
        setCollapsed,
        breadcrumb,
        setBreadcrumb,
        baseBreadcrumb,
        setBaseBreadcrumb,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function Layout(props: PropsWithChildren) {
  const { collapsed, setCollapsed /* baseBreadcrumb, breadcrumb */ } =
    useLayout()
  const prefix = 'layout'
  const { wrapSSR, hashId } = useCssInJs({
    prefix,
    styleFun: genLayoutStyle,
  })

  /*   const finalBreadcrumb = useMemo(() => {
    return [...baseBreadcrumb, ...breadcrumb]
  }, [baseBreadcrumb, breadcrumb]) */

  return wrapSSR(
    <div className={cls(prefix, hashId, collapsed ? 'collapsed' : '')}>
      <div className='slider'>
        <div className='logo'>
          <Logo collapsed={collapsed} />
        </div>
        <div className='menu'>
          <Menu />
        </div>
      </div>
      <div className='layout'>
        <div className='header'>
          <div className='tools'>
            <div
              onClick={() => setCollapsed((v) => !v)}
              className='button-collapse'
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
            {isProdEnv ? (
              <div className='global-tips'>
                <WarningFilled />
                <span>当前为正式环境，请谨慎操作</span>
              </div>
            ) : null}
            <div className='userinfo'>
              <Env />
              <UserInfo />
            </div>
          </div>
          {/* {finalBreadcrumb.length ? (
            <Breadcrumb className='breadcrumb' items={finalBreadcrumb} />
          ) : (
            <div className='breadcrumb' />
          )} */}
          {/* <div className='breadcrumb' /> */}
        </div>
        <div className='content'>
          <LazyComponent>{props.children || <Outlet />}</LazyComponent>
        </div>
      </div>
    </div>
  )
}
